import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {
    createBrowserRouter,
    createRoutesFromChildren,
    RouterProvider,
    useLocation,
    useNavigationType
} from "react-router-dom";
import HostedPaymentGatewayComponent from "./components/gateway/hostedPaymentGatewayComponent";
import ErrorPage from "./components/error/errorPage";
import SuccessPage from "./components/success/successPage";
import TransactionSuccessfulPage from "./components/success/transactionSuccessfulPage";
import TransactionFailedPage from "./components/error/transactionFailedPage";
import * as Sentry from "@sentry/react";
import { datadogRum } from '@datadog/browser-rum';
import {matchRoutes} from "react-router";
import PaymentLinkPaymentComponent from "./components/gateway/paymentLink/paymentLinkPaymentComponent";
import PaymentPage from "./components/gateway/paymentPage";

// const sentryDns = `${process.env.REACT_APP_PAYMENT_GATEWAY_DNS}`;
const environment = process.env.REACT_APP_ENVIRONMENT != undefined ? `${process.env.REACT_APP_ENVIRONMENT}` : 'dev';

if(environment === 'production' || environment === 'sandbox') {
    Sentry.init({
        dsn: "https://3075ca0055c887951b293e949628111a@o186519.ingest.sentry.io/4506676051640320",
        integrations: [
            new Sentry.BrowserTracing({
                // See docs for support of different versions of variation of react router
                // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
                routingInstrumentation: Sentry.reactRouterV6Instrumentation(
                    React.useEffect,
                    useLocation,
                    useNavigationType,
                    createRoutesFromChildren,
                    matchRoutes
                ),
            }),
            Sentry.replayIntegration()
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        tracesSampleRate: 0.1,
        enabled: true,

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: environment
    });
}

if(environment === 'production' || environment === 'sandbox') {
    datadogRum.init({
        applicationId: process.env.REACT_APP_DATADOG_RUM_APPLICATION_ID,
        clientToken: process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN,
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: 'datadoghq.com',
        service: 'gateway-hosted-payment-page',
        env: environment,
        // Specify a version number to identify the deployed version of your application in Datadog
        version: process.env.REACT_APP_VERSION,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
    });
}

const router = createBrowserRouter([
    {path: "/", element: <HostedPaymentGatewayComponent/>,},
    {path: "/error", element: <ErrorPage/>,},
    {path: "/transaction-successful", element: <TransactionSuccessfulPage/>,},
    {path: "/transaction-failed", element: <TransactionFailedPage/>,},
    {path: "/success", element: <SuccessPage/>,},
    {path: "/links/*", element: <PaymentLinkPaymentComponent/>,},
    {path: "/merchant/*", element: <PaymentPage/>,},
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RouterProvider router={router}/>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
